import React from "react"
import PropTypes from "prop-types"

export default function FeatureToggle({ children, enabled }) {
  return enabled && children
}

export const renderIf = (condition) =>
  // eslint-disable-next-line react/prop-types
  ({ children }) => (
    <FeatureToggle enabled={condition}>{children}</FeatureToggle>
  )

FeatureToggle.propTypes = {
  children: PropTypes.node.isRequired,
  enabled: PropTypes.bool,
}

FeatureToggle.defaultProps = {
  enabled: false,
}
